<template>
  <div class="container__filter-fields mb-40 max-width-280">
    <h6 class="h6__label--blue mb-24">O que você está buscando?</h6>
    <FilterInputFindByWord
      @wordChanged="wordChanged()"
      :placeholder="'ex: designer'"
      :searchWord="searchWord"
    />
  </div>

  <div class="container__filter-fields mb-40 max-width-280">
    <h6 class="h6__label--blue mb-24">Classificar por</h6>
    <FilterSelect
      :placeholder="currentSort"
      :items="orderingItems"
      @itemSelected="sortingTypeSelected($event)"
    />
  </div>

  <div class="container__filter-fields mb-40 max-width-280">
    <h6 class="h6__label--blue mb-24">Tipo de produto</h6>
    <FilterProductTypeList
      :items="typeProductList"
      @productTypeHasBeeSelected="productTypeHasBeeSelected($event)"
    />
  </div>

  <div class="container__filter-fields mb-40 max-width-280">
    <h6 class="h6__label--blue mb-24">Área de atuação</h6>
    <FilterSelect
      :placeholder="'Selecione uma área'"
      :items="technologicalAreas"
      @itemSelected="selectedTechnologyArea($event)"
    />
  </div>

  <slot></slot>
</template>

<script>
import FilterInputFindByWord from './FilterInputFindByWord.vue'
import FilterSelect from './FilterSelect.vue'
import FilterProductTypeList from './FilterProductTypeList.vue'
import { useSearch } from '../composables/useSearch'
export default {
  components: { FilterInputFindByWord, FilterSelect, FilterProductTypeList },
  name: 'FilterContainer',
  setup() {
    const {
      typeProductList,
      technologicalAreas,
      orderingItems,
      loadSearch,
      technologicalAreaId,
      sort,
      typeProductListSelected,
      resetPagination,
      currentSort,
    } = useSearch()

    const searchParams = new URLSearchParams(window.location.search)
    const searchWord = searchParams.get('search')

    async function wordChanged() {
      try {
        await loadSearch()
      } catch (error) {
        console.log(error)
      } finally {
        resetPagination()
      }
    }
    async function sortingTypeSelected(sortObj) {
      try {
        currentSort.value = sortObj.name
        const name = sortObj.name.toLowerCase()
        sort.value =
          name === 'tipo de produto'
            ? 'tipo_produto'
            : name === 'área'
            ? 'area'
            : name
        await loadSearch()
      } catch (error) {
        console.log(error)
      } finally {
        resetPagination()
      }
    }
    async function selectedTechnologyArea(area) {
      try {
        technologicalAreaId.value = area.id
        await loadSearch()
      } catch (error) {
        console.log(error)
      } finally {
        resetPagination()
      }
    }
    async function productTypeHasBeeSelected(productType) {
      try {
        typeProductListSelected.value =
          productType.value.length >= 1 ? productType.value : null
        await loadSearch()
      } catch (error) {
        console.log(error)
      } finally {
        resetPagination()
      }
    }

    return {
      typeProductList,
      wordChanged,
      searchWord,
      technologicalAreas,
      sortingTypeSelected,
      orderingItems,
      productTypeHasBeeSelected,
      selectedTechnologyArea,
      currentSort,
    }
  },
}
</script>
